module.exports = __webpack_public_path__ + "img/status-offline.8933211c.svg";